
import React from 'react';
import { ListChecks, Building, ClipboardCheck, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const SetupDealershipDashboardPage = ({ dealership }) => (
    <div>
        <div className="mb-6 flex items-center justify-between">
            <div>
                <Link
                    to="/setup"
                    className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-2"
                >
                    <ArrowLeft size={16} />
                    Back to Dealership List
                </Link>
                <h2 className="text-3xl font-bold">Managing: {dealership.name}</h2>
            </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Link to={`/setup/${dealership.id}/checklist`} className="p-6 bg-white rounded-lg shadow-md border text-center hover:shadow-xl">
                <ListChecks size={32} className="mx-auto text-blue-600 mb-2" />
                <h3 className="font-semibold">Onboarding Checklist</h3>
            </Link>
            <Link to={`/setup/${dealership.id}/locations`} className="p-6 bg-white rounded-lg shadow-md border text-center hover:shadow-xl">
                <Building size={32} className="mx-auto text-purple-600 mb-2" />
                <h3 className="font-semibold">Locations</h3>
            </Link>
            <Link to={`/setup/${dealership.id}/signoff`} className="p-6 bg-white rounded-lg shadow-md border text-center hover:shadow-xl">
                <ClipboardCheck size={32} className="mx-auto text-orange-600 mb-2" />
                <h3 className="font-semibold">Sign Off</h3>
            </Link>
        </div>
    </div>
);

export default SetupDealershipDashboardPage;
